import { useMemo } from 'react';
import styled from 'styled-components';
import { Box, Dropdown, Flex, FlexItem, Text } from '@bigcommerce/big-design';
import { ArrowDropDownIcon } from '@bigcommerce/big-design-icons';
import { CenteredText } from './StyledComponents';
import { useOrderStatuses } from '../../../../context/OrderStatuses';
import { getStatusBackground } from '../../orderStatusColors';

const StatusBadge = styled(Box)`
	background-color: ${({ status }) => getStatusBackground(status)};
	border-radius: 2px;
	width: max-content;
`;

const StatusToggleButton = styled.button`
	align-items: center;
	background-color: #ffffff;
	border: 1px solid #d9d9d9;
	border-radius: 4px;
	cursor: pointer;
	display: flex;
	justify-content: space-between;
	min-height: 2.25rem;
	padding: 0.25rem 0.5rem;
	width: 100%;
`;

const StatusToggleContent = styled.span`
	align-items: center;
	display: inline-flex;
`;

export function StatusSelect(props) {
	const { onOptionChange } = props;
	const orderStatuses = useOrderStatuses();
	const selectedValue = useMemo(() => {
		if (props.value && typeof props.value === 'object') {
			if ('value' in props.value) return props.value.value;
			if ('id' in props.value) return props.value.id;
		}
		return props.value;
	}, [props.value]);
	const selectedStatus = useMemo(
		() => orderStatuses.find((status) => status.id === selectedValue),
		[orderStatuses, selectedValue],
	);
	const statusOptions = useMemo(
		() =>
			orderStatuses.map((status) => ({
				content: (
					<StatusBadge status={status.id} paddingHorizontal="small">
						<Text color="white" margin="none">
							{status.custom_label}
						</Text>
					</StatusBadge>
				),
				onItemClick: () => onOptionChange(status.id),
			})),
		[orderStatuses, onOptionChange],
	);

	return (
		<Flex paddingRight="xLarge">
			<FlexItem flexGrow={0} paddingRight="small">
				<Text bold as={CenteredText}>
					Status:{' '}
				</Text>
			</FlexItem>
			<FlexItem flexGrow={1}>
				<Dropdown
					items={statusOptions}
					placement="bottom-start"
					disabled={!orderStatuses.length}
					toggle={
						<StatusToggleButton type="button">
							<StatusToggleContent>
								{selectedStatus ? (
									<StatusBadge
										status={selectedStatus.id}
										paddingHorizontal="small"
									>
										<Text color="white" margin="none">
											{selectedStatus.custom_label}
										</Text>
									</StatusBadge>
								) : (
									<Text color="secondary60" margin="none">
										Select Status
									</Text>
								)}
							</StatusToggleContent>
							<ArrowDropDownIcon color="secondary60" />
						</StatusToggleButton>
					}
				/>
			</FlexItem>
		</Flex>
	);
}
